import moment from 'moment'

export const displayDateFromClinicalImpression = clinicalImpression => {
  if (clinicalImpression.date == null) {
    return null
  }
  return moment(clinicalImpression.date).format('DD/MM/YYYY')
}
